export default {
  login: '/api/auth/login',
  logout: '/api/auth/logout',
  check_login: '/api/auth/check-login',
  programari: '/api/bookings',
  comenzi: '/api/comenzi',
  invoice: '/api/invoice',
  devize: '/api/devize',
  comanda_noua: '/api/comenzi',
  update_comanda: '/api/comenzi/update',
  save_formular_comanda: '/api/comenzi/save-formular-comanda',
  save_deviz: '/api/comenzi/save-deviz',
  get_clienti: '/api/clienti',
  scan_id_card: '/api/clienti/scan-id-card',
  templates: '/api/templates',
  intrari_by_date_range: '/api/comenzi/get-intrari-by-date-range',
  deviz: '/api/deviz',
  cars: '/api/cars',
  links: '/api/links',
  scan_talon: '/api/scan-talon',
  setari_rar: '/api/setari/rar',
  rar_login: '/api/rar/login',
  slack_message: '/api/slack-message',
  log_fe_error: '/api/log-fe-error',
  replay_sessions: '/api/screen-sessions'
}
